<app-inline-loader></app-inline-loader>
<div class="nav-margin"></div>
<div class="{{pageClass}}" appVerifyVehicleCta>
  <span *ngIf="showOutOfWarranty" class="d-none justify-content-center w-100 text-center inspection-banner pt-2 pb-2">{{
    'RATES_PAGE.OUT_OF_WARRANTY' | translate }}</span>
  <div *ngFor="let slice of slices">
    @switch (slice?.type) {
      @case ('images_slider') {
        <ngx-slick-carousel class="carousel">
          <div ngxSlickItem *ngFor="let field of slice.fields" class="slide">
            <img class="d-block w-100" [src]="field.desktop_image.url" alt="First slide">
          </div>
        </ngx-slick-carousel>
      }
      @case ('hero') {
        <app-slice-hero-section [vehicleObject]="vehicleObject" [slice]="slice"
          (emitOpenModal)="openModal($event)"></app-slice-hero-section>
      }
      @case ('plans') {
        <app-slice-plans [slice]="slice" [vehicleObject]="vehicleObject"
          (emitOpenModal)="openModal($event)"></app-slice-plans>
      }
      @case ('content_block') {
        @if (showContentBlockDiv(slice)) {
          <div class="m-0 p-0 w-100">
            <app-slice-content-block [slice]="slice" [vehicleObject]="vehicleObject"
              (emitOpenModal)="openModal($event)"></app-slice-content-block>
          </div>
        }
      }
      @case ('faq') {
        <app-slice-faq [vehicleObject]="vehicleObject" [slice]="slice"
          (emitOpenModal)="openModal($event)"></app-slice-faq>
      }
      @case ('image') {
        <app-slice-image [slice]="slice"></app-slice-image>
      }
      @case ('title') {
        <app-slice-title [slice]="slice" [vehicle]="vehicleObject"></app-slice-title>
      }
      @case ('text') {
        <app-slice-text [slice]="slice" [vehicle]="vehicleObject"></app-slice-text>
      }
      @case ('products_tabset') {
        <div>
          @if (slice?.primary?.product?.use_new_rates_ui || slice?.primary?.product?.new_rates_card_brand_color) {
            <app-slice-product-tabset-new
              [vehicle]="vehicleObject" [slice]="slice"></app-slice-product-tabset-new>
          } @else {
            <app-slice-product-tabset
              [vehicle]="vehicleObject" [slice]="slice"></app-slice-product-tabset>
          }
        </div>
      }
      @case ('product') {
        <app-slice-product [slice]="slice" [vehicleObject]="vehicleObject"
          (emitOpenModal)="openModal($event)"></app-slice-product>
      }
    }
  </div>
</div>
